module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgdmlld0JveD0iLTggMCAzMiAzMiI+CiAgICA8cGF0aCBkPSJNMTUuNTUyIDE1LjE2OHEwLjQ0OCAwLjMyIDAuNDQ4IDAuODMyIDAgMC40NDgtMC40NDggMC43NjhsLTEzLjY5NiA4LjUxMnEtMC43NjggMC41MTItMS4zMTIgMC4xOTJ0LTAuNTQ0LTEuMjh2LTE2LjQ0OHEwLTAuOTYgMC41NDQtMS4yOHQxLjMxMiAwLjE5MnoiPjwvcGF0aD4KPC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/components/aplayer/assets/play.svg
// module id = VT6x
// module chunks = 29